import {
    Sheet,
    SheetContent,
    SheetDescription,
} from "@/components/ui/sheet";
import { Dispatch, FC, SetStateAction } from "react";
import { CirclePlus, Gauge, Calendar, Fingerprint } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Vehicle } from "@/interface/entityInterface";

interface Props {
    data: Vehicle | null;
    isSheetOpen: boolean;
    setIsSheetOpen: Dispatch<SetStateAction<boolean>>;
}

const VehicleDetails: FC<Props> = ({ data, isSheetOpen, setIsSheetOpen }) => {    
    if (!data) return;

    return (
        <Sheet open={isSheetOpen} onOpenChange={setIsSheetOpen}>
            <SheetContent side="bottom" className="p-10">
                <p className="text-[35px] mb-[-15px]">Vehicle Details</p>
                <SheetDescription className="text-lg">Details and configuration of the selected vehicle</SheetDescription>
                
                <div className="grid lg:grid-cols-2 place-items-start gap-x-5">
        <div className="w-full grid grid-cols-1 gap-4">
            <div className="w-full h-full">
                <img className="w-full h-auto max-h-[400px] object-contain object-center lg:max-h-[600px] lg:object-cover lg:object-left" src="/image.png" />
            </div>
        </div>
        <div className="w-full grid grid-cols-2 place-items-center gap-5">
            <div className="col-span-2 flex items-center justify-center gap-4">
                {data?.make?.logo && (
                    <img src={data.make.logo} alt="Logo" className="h-30 w-30 object-contain" />
                )}
                <div>
                    <p className="text-[40px] font-semibold mb-[-10px]">{data?.nickname || "Unnamed Vehicle"}</p>
                    <p className="text-[20px] text-muted-foreground">{data?.make?.name || "Unknown Make"} {data?.make_model}</p>
                </div>
            </div>
            <div className="h-28 w-full bg-muted rounded-xl flex flex-col items-center justify-center">
                <CirclePlus className="h-6 w-6 text-primary mb-2" />
                <p className="text-xs text-muted-foreground">Fuel Type</p>
                <p className="font-medium">{data?.vehicle_tanks?.[0]?.fuel?.name || "N/A"}</p>
            </div>
            <div className="h-28 w-full bg-muted rounded-xl flex flex-col items-center justify-center">
                <Gauge className="h-6 w-6 text-primary mb-2" />
                <p className="text-xs text-muted-foreground">KM Type</p>
                <p className="font-medium uppercase">{data?.km_type}</p>
            </div>
            <div className="h-28 w-full bg-muted rounded-xl flex flex-col items-center justify-center">
                <Calendar className="h-6 w-6 text-primary mb-2" />
                <p className="text-xs text-muted-foreground">Year</p>
                <p className="font-medium">{data?.make_year}</p>
            </div>
            <div className="h-28 w-full bg-muted rounded-xl flex flex-col items-center justify-center">
                <Badge variant="outline" className="h-6 w-6 text-primary mb-2">#</Badge>
                <p className="text-xs text-muted-foreground">License Plate</p>
                <p className="font-medium">{data?.license_plate}</p>
            </div>
            <div className="h-28 w-full bg-muted rounded-xl flex flex-col items-center justify-center">
                <Fingerprint className="h-6 w-6 text-primary mb-2" />
                <p className="text-xs text-muted-foreground">VIN</p>
                <p className="font-medium">{data?.identification_vin || "N/A"}</p>
            </div>
            <div className="h-28 w-full bg-muted rounded-xl flex flex-col items-center justify-center">
                <Fingerprint className="h-6 w-6 text-primary mb-2" />
                <p className="text-xs text-muted-foreground">Odometer</p>
                <p className="font-medium">{data?.last_odometer} {data?.km_type}</p>
            </div>
            {/* <div className="h-32 w-full bg-muted rounded-xl flex flex-col items-center justify-center">
                <FanIcon className="h-6 w-6 text-primary mb-2" />
                <p className="text-xs text-muted-foreground">AC</p>
                <p className="font-medium">{data?.has_ac ? "Yes" : "No"}</p>
            </div> */}
        </div>
    </div>
                {/* <div className="grid grid-cols-12 gap-4">
                    <div className="grid gap-1">
                        <div>
                            <p className="font-semibold">License Plate</p>
                            <Badge variant="outline" className="text-[20px] px-3 py-1">{data.license_plate || "N/A"}</Badge>
                            <p className="mt-3 font-semibold">Type</p>
                            <Badge variant="outline" className="capitalize">{data.type}</Badge>
                        </div>
                    </div>
                    <div className="grid gap-1">
                        {data.vehicle_tanks?.length > 0 && (
                            <div>
                                <p className="font-semibold">Fuel Type:</p>
                                <Badge variant="secondary">{data.vehicle_tanks[0].fuel?.name}</Badge>

                                <p className="mt-3 font-semibold">Tank Capacity:</p>
                                <p>{data.vehicle_tanks[0].unit_capacity} L</p>
                            </div>
                        )}
                    </div>
                </div> */}
            </SheetContent>
        </Sheet>
    );
};

export default VehicleDetails;